import { Modify } from "@biblioteksentralen/types";
import { resolveContact, ResolvedContact } from "../../employees";
import { Service, ServiceType } from "@libry-content/types";
import groq from "groq";
import {
  ResolvedLibrarySummary,
  resolveLibrarySummary,
} from "../../../../../apps/frontend/src/components/library/sanityQuery";

export const resolveServiceGroqProjecton = groq`
  ...,
  serviceType->,
  contact->${resolveContact},
  libraries[]->{${resolveLibrarySummary}}
`;

export type ResolvedService = Modify<
  Service,
  { serviceType?: ServiceType; contact?: ResolvedContact; libraries?: ResolvedLibrarySummary[] }
>;

export const resolveServiceSummary = groq`
  _type,
  _id,
  title,
  image,
  targetAudiences,
  teaser,
  promotion,
  basicService,
  libraries[]->{${resolveLibrarySummary}},
  serviceType->{
    _id,
    label
  }
`;

export type ResolvedServiceSummary = Pick<
  Service,
  "_id" | "title" | "_type" | "image" | "targetAudiences" | "teaser" | "promotion" | "basicService"
> & {
  serviceType?: Pick<ServiceType, "_id" | "label">;
  libraries?: ResolvedLibrarySummary[];
};
